if (!customElements.get('type-search')) {
  class TypeSearch extends HTMLElement {
    constructor() {
      super();
      this.type = this.getAttribute('type') || 'collection';
      this.terms = this.getAttribute('terms') || '';
      this.limit = this.getAttribute('limit') || '6';
      this.resultsContainer =
        this.querySelector('[data-type-search-results]') || this.querySelector('#type-search');
    }

    connectedCallback() {
      if (!this.resultsContainer || !this.terms) return;
      this.getSearchResults();
    }

    getSearchResults() {
      const params = new URLSearchParams({
        q: this.terms,
        'resources[type]': this.type,
        'resources[options][unavailable_products]': 'hide',
        'resources[limit]': this.limit,
        section_id: 'type-search',
      });

      fetch(`/search/suggest?${params.toString()}`)
        .then((response) => response.text())
        .then((responseText) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(responseText, 'text/html');
          const sectionMarkup =
            doc.querySelector('#shopify-section-type-search') ||
            doc.querySelector('[id^="shopify-section-"][id$="type-search"]') ||
            doc.querySelector('[id*="shopify-section"][id*="type-search"]');

          if (sectionMarkup) {
            this.resultsContainer.innerHTML = sectionMarkup.innerHTML;
            return;
          }

          this.resultsContainer.innerHTML = responseText;
        })
        .catch(() => {
          this.resultsContainer.innerHTML = '';
        });
    }
  }

  customElements.define('type-search', TypeSearch);
}
